<template>
  <div class="dashboard-projects">
    <dashboard-entities-loading v-if="isLoading" :view-type="viewType" />
    <dashboard-entities-view
      v-else
      :view-type="viewType"
      :entities="projects"
      :daily-activity-logs="dailyActivityLogs"
      :profile="profile"
      :is-searching="isSearching"
      entity-type="projects"
      @toggle-favorite="(entity: any) => toggleFavorite(entity)"
      @entity-archived="(entity: any) => $emit('project-archived', entity)"
    />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */
import DashboardListMixin from '@/screens/dashboard/mixins/dashboard-list.mixin'

/* Components */

/* Helpers */

/* Data types */
import {
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogsDailyActivityLog,
} from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default defineComponent({
  extends: DashboardListMixin,

  props: {
    /**
     * View Type: Grid or Table
     */
    viewType: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isSearching: {
      type: Boolean,
      required: true,
    },
    projects: {
      type: Array as () => IProjectsOutputProjectForHome[],
      required: true,
    },
    dailyActivityLogs: {
      type: Array as () => IProjectDailyActivityLogsDailyActivityLog[],
      default: null,
    },
  },

  emits: ['project-archived'],

  computed: {
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
  },
  methods: {
    async setFavorite(item: any) {
      if (item.isFavorite) {
        await InternalProjectsAPI.post_Favorite(item.id)
      } else {
        await InternalProjectsAPI.post_Unfavorite(item.id)
      }
    },

    async toggleFavorite(item: any) {
      try {
        // This will set the star on the item correctly since it's connected by ref...
        item.isFavorite = !item.isFavorite
        // This actually sets the update in the API...
        await this.setFavorite(item)
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
</script>

<style lang="scss">
.dashboard-projects {
  margin-bottom: 18px;
}
</style>
